module.exports = __webpack_public_path__ + "img/MASTER_CHN_VP_Handbook_Web33.a372cdbd.jpg";